/* @flow */
import React from 'react';

import Group from 'entities/Group';
import GroupInviteBulkAddTab from 'groups/components/GroupInviteBulkAddTab.jsx';
import TabPanel from 'components/TabPanel.jsx';

class InviteManualAddTab extends React.Component {
  props: {
    group: Group,
    smsEnabled: boolean,
    title: mixed,
  }

  render() {
    const { group, smsEnabled, title } = this.props;

    return (
      <TabPanel
        key="manualAddPanel"
        selectedBorderColor="brand"
        className="InviteManualAddTab"
        eventElementName="tab-text-email-invitation"
        title={title}>
        <GroupInviteBulkAddTab group={group} supportSms={smsEnabled} />
      </TabPanel>
    );
  }
}

export default InviteManualAddTab;



// WEBPACK FOOTER //
// ./src/groups/components/InviteManualAddTab.jsx